import React from "react";
import { cn } from "~/lib/utils";
type TagProps = {
  text: string;
  className?: string;
};
const Tag: React.FC<TagProps> = ({ text, className }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center bg-cardBg border border-textHeadingColor  text-textHeadingColor text-xs px-2 py-0.5 rounded-lg font-abcArizonaFlareVariable font-medium",
        className,
      )}
    >
      <span className="mt-0.5 capitalize">{text}</span>
    </div>
  );
};

export default Tag;
